import { Stack, Typography } from '@lyearn/ui';

import { SectionRendererProps } from '../../types';

function SectionRenderer(props: SectionRendererProps) {
  const { sectionIndex, section, ...rest } = props;
  return (
    <Stack alignItems="center" className="w-full pb-24 pt-24" justifyContent="between">
      <Typography variant="display-xs" {...rest}>
        {sectionIndex + 1}. {section.label}
      </Typography>
    </Stack>
  );
}

export default SectionRenderer;
